import $ from 'jquery'
import { Text, Fill, Stroke, Icon, Circle, Style } from 'ol/style'

/**
 * @api
 */

const defaultStyle = {
  stroke: {
    color: 'rgba(255, 0, 0, 1)',
    width: 4
  },
  fill: {
    color: 'rgba(255, 0, 0, 0.2)'
  },
  point: {
    radius: 5,
    color: 'rgba(255, 0, 0, 1)'
  },
  text: {
    font: 'normal 18px Helvetica',
    property: null,
    offsetX: 0,
    offsetY: 0,
    fill: {
      color: 'rgba(0, 0, 0, 1)'
    },
    stroke: {
      color: 'rgba(255,255,255, 1)',
      width: 2
    },
    minResolution: 0,
    maxResolution: Infinity
  }
}

function parseValue(feature, value) {
  return typeof value === 'object' && !Array.isArray(value)
    ? value.mapping[feature.get(value.property)]
    : value
}

/**
 * Create style
 * @param {object} style
 * @return {Style} OpenLayers style object
 */
export const parseStyle = function(styleOverride) {
  var style = $.extend(true, {}, defaultStyle, styleOverride)

  var textParser = function(feature, resolution) {
    var displayText = ''
    if (
      style.text.property &&
      resolution >= style.text.minResolution &&
      resolution <= style.text.maxResolution
    ) {
      displayText = feature.get(style.text.property) || ''
    }

    const textObj = new Text({
      font: style.text.font,
      text: `${displayText}`,
      offsetX: style.text.offsetX,
      offsetY: style.text.offsetY,
      fill: new Fill({
        color: parseValue(feature, style.text.fill.color)
      }),
      stroke: new Stroke({
        color: parseValue(feature, style.text.stroke.color),
        width: parseValue(feature, style.text.stroke.width)
      }),
      scale: 1,
      overflow: style.text.overflow === undefined ? true : style.text.overflow,
      exceedLength:
        style.text.overflow === undefined ? true : style.text.overflow
    })

    return textObj
  }

  return function(feature, resolution) {
    let image = null
    if (style.point.icon) {
      const iconDefintion = Object.keys(style.point.icon).reduce(
        (result, key) => {
          result[key] = parseValue(feature, style.point.icon[key])
          return result
        },
        {}
      )
      image = new Icon(iconDefintion)
    } else {
      image = new Circle({
        radius: parseValue(feature, style.point.radius || style.stroke.width),
        fill: new Fill({
          color: parseValue(feature, style.point.color || style.stroke.color)
        }),
        stroke: new Stroke({
          width: parseValue(feature, style.stroke.width),
          color: parseValue(feature, style.stroke.color)
        })
      })
    }

    const styleObj = new Style({
      stroke: new Stroke({
        color: parseValue(feature, style.stroke.color),
        width: parseValue(feature, style.stroke.width)
      }),
      fill: new Fill({
        color: parseValue(feature, style.fill.color)
      }),
      image,
      text: textParser(feature, resolution)
    })

    return [styleObj]
  }
}
